import React, { useRef } from "react";
import "../../../Assets/Css/EmployeeDocument.scss";
import Table from "../../../Components/Table";
import { useLocation, useNavigate } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import { useEffect } from "react";
import { useState } from "react";
import { connect } from "react-redux";
import qs from "query-string";
import { toast } from "react-toastify";
import { Spinner } from "react-bootstrap";
import { addDocument, getDocuments } from "../../../Services/Document/action";
import { deleteRecord } from "../../../Services/Delete/action";
import moment from "moment";
import AddDocumentModal from "../../../Components/AddDocumentModal";
import { getUsers } from "../../../Services/Users/action";
import FeaturesList from "../../../Assets/FeaturesList";
import ModulesList from "../../../Assets/ModulesLiist";
import RoleWiseFeatureWrapper, { checkFeatureAccess } from "../../../Lib/RoleWiseFeatureWrapper";
import Skeleton from "react-loading-skeleton";

const EmpDocument = (props) => {
    const [checked, setChecked] = useState(false);
    const [selectedId, setSelectedId] = useState([]);
    const [params, setParams] = useState({});
    const [totalSelectedIds, setTotalSelectedIds] = useState([]);
    const [exportLoading, setExportrLoading] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [inData, setInData] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);
    const [fileName, setFileName] = useState('');
    const [loading, setLoading] = useState(false);
    const [hasError, setHasError] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [fileType, setFileType] = useState('');
    const [files, setFiles] = useState([]);
    const [previews, setPreviews] = useState([]);
    const fileInputRef = useRef(null);
    const modalRef = useRef(null);

    const canView = checkFeatureAccess({
        modules: props?.modules,
        features: props?.features,
        user: props?.user,
        ModuleName: ModulesList.Documents,
        Featur_Name: FeaturesList.View,
    });

    const canDelete = checkFeatureAccess({
        modules: props?.modules,
        features: props?.features,
        user: props?.user,
        ModuleName: ModulesList.Documents,
        Featur_Name: FeaturesList.Delete,
    });

    const navigate = useNavigate();
    const location = useLocation();

    const header = [
        { field: "ID" },
        { field: "Document" },
        { field: "Type" },
        { field: "Last Modified" },
        { field: "Action" },
    ];

    let footer = true;
    let count = inData?.length;

    useEffect(() => {
        setIsLoading(true)
        fetchData();
        setIsLoading(false)
    }, [location.search]);

    const fetchData = async () => {
        try {
            setParams(qs.parse(location.search, { ignoreQueryPrefix: true }));
            await props.getDocuments();
        } catch (error) {
            console.error("Error fetching documents:", error);
        }
    };

    useEffect(() => {
        const updateContent = async () => {
            const content = await Promise.all(
                props?.document?.filter((doc) => doc?.employee_id === props?.user?.id)?.map((item) => {

                    let url;
                    const byteArray = new Uint8Array(item.document.data);
                    const stringData = new TextDecoder().decode(byteArray);

                    let base64String = '';
                    let mimeType = '';

                    if (stringData.startsWith('data:')) {
                        const match = stringData.match(/^data:(.*?);base64,(.*)$/);
                        if (match) {
                            mimeType = match[1];
                            base64String = match[2];
                        }
                    } else {
                        // Default to binary PDF (fallback)
                        mimeType = 'application/pdf';
                        base64String = btoa(String.fromCharCode(...byteArray));
                    }

                    try {
                        const binaryString = atob(base64String);
                        const len = binaryString.length;
                        const bytes = new Uint8Array(len);
                        for (let i = 0; i < len; i++) {
                            bytes[i] = binaryString.charCodeAt(i);
                        }

                        const blob = new Blob([bytes], { type: mimeType });
                        url = URL.createObjectURL(blob);

                    } catch (error) {
                        console.error('Error decoding base64 or creating blob:', error);
                    }

                    return {
                        "ID": {
                            value: item?.id,
                            type: "text",
                        },
                        "Document": {
                            value: item?.name,
                            type: "documents",
                        },
                        "Type": {
                            value: item?.doc_type,
                            type: "text",
                        },
                        "Last Modified": {
                            value: moment(item?.updatedAt)?.fromNow(),
                            type: "text",
                        },
                        Action: {
                            value: "/document/empdocument/edit",
                            value2: "/document/empdocument/view",
                            value1: url,
                            value3: item?.id,
                            fileName: `${item?.name?.split(".")[0]}_${item?.doc_type}`,
                            type: "action",
                        },
                        allData: {
                            ...item
                        }
                    };
                }))
            setInData(content);
        }
        updateContent();
    }, [props]);

    const handleClose = () => {
        setShowModal(false);
        setFileName('');
        setSelectedFile(null);
        fileInputRef.current.value = null;
    };


    const handleFileChange = (event) => {
        if (files.length > 0) {
            toast.error("You can upload only one file. Please remove the existing one first.");
            return;
        }
        const newFiles = Array.from(event.target.files);
        const newPreviews = newFiles.map(file => URL.createObjectURL(file));

        setFiles(prevFiles => [...prevFiles, ...newFiles]);
        setPreviews(prevPreviews => [...prevPreviews, ...newPreviews]);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                handleClose();
                setFileName('');
                setSelectedFile(null);
                fileInputRef.current.value = null;
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [handleClose]);

    const handleChange = (event) => {
        const { type, checked, id, ids } = event;

        if (type === "select-all") {
            setTotalSelectedIds(checked ? [...ids] : []);
        } else if (type === "select-one") {
            if (checked) {
                setTotalSelectedIds(prev => [...prev, id]);
            } else {
                setTotalSelectedIds(prev => prev.filter(selectedId => selectedId !== id));
            }
        }
    };

    const handleClick = async (totalSelectedIds, type) => {
        let ids = totalSelectedIds.map((id) => parseFloat(id));

        try {
            if (type === "delete") {
                setDeleteLoading(true);
                await props.deletePurchaseInvoices(ids);
                setChecked(false);
                setTotalSelectedIds([]);
            } else if (type === "export") {
                setExportrLoading(true);
                await handlePdfDownload(ids);
                toast.success("Exported Successfully");
            }
        } catch (error) {
            console.error(error);
        } finally {
            await fetchData();
            setDeleteLoading(false);
        }
    };

    const initialState = {
        name: "",
    }
    const [clientData, setClientData] = useState(initialState);

    const fileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };

    const handleAdd = async () => {
        try {
            if (!fileType || files?.length == 0) {
                toast.error("Please fill all the required fields");
                return
            }

            const file = files[0];
            const base64File = await fileToBase64(file);
            const body = {
                name: file?.name,
                document: base64File,
                doc_type: fileType?.val?.value,
                employee_id: props?.user?.id
            }
            await props?.addDocument(body);
            onClose();
        } catch (error) {
            console.error("Error adding document:", error);
        }
    }

    const openModal = () => setShowModal(true);
    const onClose = () => {
        setShowModal(false);
        setFileType('')
        setFiles([]);
        setPreviews([]);
    }

    useEffect(() => {
        return () => {
            previews.forEach(preview => URL.revokeObjectURL(preview));
        };
    }, [previews]);

    const handleRemoveFile = (index) => {
        setFiles(files.filter((_, i) => i !== index));
        setPreviews(previews.filter((_, i) => i !== index));
    };

    const searchFiled = (e) => {
        const { name, value } = e.target;
        setClientData((preVal) => ({
            ...preVal,
            [name]: value
        }))
    }
    const DocumentTypes = [
        'Aadhar Card',
        'PAN Card',
        'Driving Licence',
        'Passbook',
        'Photograph',
    ];

    const uploadedTypes = props?.document?.filter(doc => doc?.user?.id === props?.user?.id)?.map(item => item?.doc_type);

    const missingTypes = DocumentTypes.filter(
        requiredType => !uploadedTypes?.includes(requiredType)
    );

    return (
        <div className="empDocument-main">
            <div className="empDocument-page-title">
                <h4>
                    {
                        props.loading ? (
                            <Skeleton className="rounded-2 mb-3" width={200} height={40} />
                        ) : (
                            <>
                                Documents
                                <span className="warning-text" style={{ fontSize: "14px" }}>
                                    {missingTypes && `( The following documents are missing: ${missingTypes?.map(item => item)?.join(', ')}. * )`}
                                </span>
                            </>
                        )
                    }
                </h4>
                <div>
                    {
                        props.loading ? (
                            <Skeleton className="badge rounded-pill" width={100} height={40} />
                        ) : (
                            <RoleWiseFeatureWrapper
                                modules={props?.modules}
                                features={props?.features}
                                user={props?.user}
                                ModuleName={ModulesList.Documents}
                                Featur_Name={FeaturesList.Create}>

                                <button className="custom-document-btn" disabled={props.loading} onClick={openModal}>
                                    Add Document
                                </button>
                            </RoleWiseFeatureWrapper>
                        )
                    }
                </div>
            </div>

            <div className="row mb-4" >
                <div className="col-lg-4">
                    {
                        props.loading ? (
                            <Skeleton className="rounded-2" width="100%" height={40} />
                        ) : (
                            <div className="input-group">
                                <input type="text" className="input-css" name='documentname' placeholder='Search' onChange={searchFiled} />
                            </div>
                        )
                    }
                </div>
            </div>

            <div className="gap-4 document-export-btn">
                <div>


                    {/* <button
                            className="export-btn"
                            id="exportBtn"
                            disabled={!checked || exportLoading}
                            onClick={(e) => {
                                e.preventDefault();
                                handleClick(totalSelectedIds, "export");
                            }}
                        >
                            {exportLoading ? (
                                <Spinner
                                    as="span"
                                    animation="border"
                                    className="custom-spinner"
                                    role="status"
                                    aria-hidden="true"
                                />
                            ) : (
                                "Export"
                            )}
                        </button> */}
                </div>
            </div>

            <div className="invoice-table-part">
                {
                    props.loading ? (
                        <Skeleton className="roundec-2" count={5} width="100%" height={40} />
                    ) : (
                        <Table
                            header={header}
                            data={inData}
                            footer={footer}
                            count={count}
                            checked={checked}
                            records={count}
                            totalSelectedIds={totalSelectedIds}
                            defaultParams={params}
                            selectedId={selectedId}
                            handleChange={handleChange}
                            loading={props.loading}
                            showIsView={canView}
                            showIsDownload={true}
                            showIsDelete={canDelete}
                            deleteRecord={props?.deleteRecord}
                        />
                    )
                }
            </div>

            {/* <EmpAddDocumentModal isModalVisible={isModalVisible} closeModal={closeModal} /> */}
            <AddDocumentModal
                showModal={showModal}
                onClose={onClose}
                handleRemoveFile={handleRemoveFile}
                previews={previews}
                handleFileChange={handleFileChange}
                handleAdd={handleAdd}
                fileType={fileType}
                setFileType={setFileType}
                files={files}
            />
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        loading: state.documentReducer.loading,
        project: state.projectReducer.project,
        document: state.documentReducer.document,
        modules: state.authenticationReducer.modules,
        features: state.authenticationReducer.features,
        user: state.authenticationReducer.user,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getUsers: () => {
            dispatch(getUsers());
        },
        getDocuments: () => {
            dispatch(getDocuments());
        },
        addDocument: (data) => {
            dispatch(addDocument(data));
        },
        deleteRecord: async (id, inputValue) => {
            await dispatch(deleteRecord(id, inputValue));
            await dispatch(getDocuments());
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EmpDocument);